import { APP_CONFIG } from "../constants";
import { AppError } from "../utils/errorHandler";

export type MobileBroadcastType = "INFO" | "WARN" | "SUCCESS" | "ERROR";

export type MobileBroadcastRecipientRow = {
  id: number;
  usuarioId: number;
  nome: string;
  email: string;
  dismissedAt: string | null;
};

export type MobileBroadcastRow = {
  id: number;
  content: string;
  type: MobileBroadcastType;
  durationSeconds: number;
  playSound: boolean;
  createdAt: string;
  createdBy: { id: number; nome: string };
  recipientCount: number;
  dismissedCount: number;
  recipients: MobileBroadcastRecipientRow[];
};

export type MobileBroadcastPage = {
  data: MobileBroadcastRow[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type CreateMobileBroadcastPayload = {
  content: string;
  type: MobileBroadcastType;
  durationSeconds: number;
  playSound: boolean;
  usuarioIds: number[];
};

async function parseError(response: Response): Promise<never> {
  try {
    const data = (await response.json()) as {
      message?: string | string[];
    };
    const msg = Array.isArray(data.message)
      ? data.message[0]
      : data.message || response.statusText;
    throw new AppError(msg, response.status);
  } catch (e) {
    if (e instanceof AppError) throw e;
    throw new AppError(response.statusText, response.status);
  }
}

function authHeaders(): HeadersInit {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export const mobileBroadcastAdminService = {
  list: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<MobileBroadcastPage> => {
    const search = new URLSearchParams();
    search.set("page", String(params?.page ?? 1));
    search.set("limit", String(params?.limit ?? 10));
    const res = await fetch(
      `${APP_CONFIG.API_URL}/admin/mobile-broadcast?${search.toString()}`,
      { headers: authHeaders() }
    );
    if (!res.ok) await parseError(res);
    return res.json();
  },

  create: async (
    payload: CreateMobileBroadcastPayload
  ): Promise<{ message: MobileBroadcastRow }> => {
    const res = await fetch(`${APP_CONFIG.API_URL}/admin/mobile-broadcast`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) await parseError(res);
    return res.json();
  },

  delete: async (id: number): Promise<void> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/admin/mobile-broadcast/${id}`,
      { method: "DELETE", headers: authHeaders() }
    );
    if (!res.ok) await parseError(res);
  },
};
